export default __webpack_public_path__ + "static/media/offer-icon-expired.1d3820e0.svg";